import { useContext } from "react";
import { AuthContext, AuthContextType } from "../../../context/AuthProvider";

interface ProfileImageProps {
	onClick?: () => void;
	className?: string;
}

const ProfileImage: React.FC<ProfileImageProps> = ({
	onClick,
	className = "w-20 h-20 border-2 border-primary-active"
}) => {
	const { user } = useContext(AuthContext) as AuthContextType;

	const getInitials = (name: any): string => {
		if (!name) return "";

		// Split by spaces and get first letter of each part
		const nameParts: string[] = name.split(" ");

		if (nameParts.length === 1) {
			// If only one name, take first letter
			return nameParts[0].charAt(0).toUpperCase();
		} else {
			// Get first letter of first name and first letter of last name
			return (
				nameParts[0].charAt(0).toUpperCase() +
				nameParts[nameParts.length - 1].charAt(0).toUpperCase()
			);
		}
	};

	return (
		<>
			{/* TODO: What if users is not Logged in?  */}
			{/* TODO: Cache image so that we don't get rate limit errors. */}
			{/* TODO: if we get rate limit error or other error, gracefully move to the second option. */}
			{user?.photoURL && (
				<img
					className={`rounded-full overflow-hidden m-1  ${onClick ? "cursor-pointer" : ""} ${className}`}
					src={user.photoURL}
					alt={`User profile avatar of ${user.displayName}`}
					// See https://stackoverflow.com/a/72463692
					referrerPolicy="no-referrer"
					onClick={onClick}
				/>
			)}
			{!user?.photoURL && (
				<div
					className={`rounded-full overflow-hidden m-1 text-primary bg-primary-background flex items-center justify-center font-bold text-xl ${onClick ? "cursor-pointer" : ""} ${className}`}
					onClick={onClick}
					aria-label={`User profile avatar of ${user?.displayName}`}
				>
					{getInitials(user?.displayName)}
				</div>
			)}
		</>
	);
};

export default ProfileImage;
